import { useContext } from "react";
import DocumentContext from "contexts/DocumentContext";

const useDocumentContext = () => {
  return useContext(DocumentContext);
};

export default useDocumentContext;
